// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--qk1IC","anchor-next":"a10a3f92e9--anchor-next--WO5mV","anchor-icon":"a10a3f92e9--anchor-icon--_ouuy"};